<template>
  <transition name="modal">
    <div
      v-show="showModal"
      v-if="loaded"
      class="modal-mask"
      @keyup.esc="showModal = false"
    >
      <v-icon v-ripple class="close-modal-btn" @click="showModal = false">
        mdi-window-close
      </v-icon>
      <v-container style="max-width: 1280px" class="mt-6">
        <v-row justify="center" no-gutters>
          <v-col cols="10" sm="4">
            <v-select
              v-if="categories"
              v-model="category"
              :items="categories"
              label="Catégorie"
              class="selector"
              solo
            />
          </v-col>
          <v-col v-if="brands.length > 2" cols="10" sm="4">
            <v-select
              v-model="brand"
              :items="brands"
              label="Marque"
              class="selector"
              solo
            />
          </v-col>
          <v-col cols="10" sm="4">
            <v-select
              v-if="colors"
              v-model="color"
              :items="colors"
              label="Couleur"
              class="selector"
              solo
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="(product, key) in products_key"
            :key="key"
            cols="6"
            md="3"
            sm="4"
            lg="3"
          >
            <product-card
              class="selectable"
              :product="product"
              @click="selectProduct(product)"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ProductSelector",
  props: {
    loaded: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    showModal: false,
    category: undefined,
    brand: undefined,
    color: undefined,
    selected: undefined,
  }),

  /*
  watch: {
    products_key(value) {
      console.log("PRODUCTS CHAMGED")
      this.categories = new Set(Object.values(value).map(p=>p.normalized_category||p.category))
    }
  },
  */

  computed: {
    products_key: {
      get: function () {
        return this.$store.getters.filterProducts(
          this.category,
          this.brand,
          this.color
        );
      },
    },
    categories: {
      get: function () {
        return this.$store.state.product.categories;
      },
    },
    brands: {
      get: function () {
        return this.$store.state.product.brands;
      },
    },
    colors: {
      get: function () {
        return this.$store.state.product.colors;
      },
    },
  },
  methods: {
    selectProduct(product) {
      this.$emit("selected", product);
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.selectable:hover {
  border: 2px solid #ccc;
  cursor: pointer;
}

.selector {
  padding: 8px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.3s ease;
  overflow: auto;
}
.close-modal-btn {
  color: white;
  font-size: 43px;
  padding: 4px;
  border-radius: 50%;
  right: 4%;
  top: 22px;
  position: fixed;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.2);
}
.close-modal-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
